var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindshieldOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 21,
    viewBox: "0 0 46 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31256 13.0882L2.95508 12.1945H3.90836L3.31256 13.0882Z",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5291 13.6244L43.827 12.7307H42.9333L43.5291 13.6244Z",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0828 1.76778C35.1295 2.14909 18.9237 1.6089 10.94 1.29114L3.55207 14.3392C2.42021 17.4373 3.55198 18.1035 5.04157 18.5098C11.5954 20.2972 33.9975 21.1313 41.5642 19.046C44.4769 18.2433 44.0069 16.1663 43.3516 14.935L36.0828 1.76778Z",
    fill: "#E75300",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0102 17.0202L32.5674 18.6289L22.2005 19.1651L20.3535 19.9397H22.4984L32.5674 18.9268L35.0102 17.0202ZM35.0102 17.0202L41.8023 15.5307L42.3386 14.8754L36.2614 16.2457L30.0651 18.4502L35.0102 17.0202Z",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9698 17.0204L16.1824 18.0928L7.42412 17.8545L5.63672 18.3312L7.42412 18.8078L16.3016 18.3312L17.5148 17.3779M17.9698 17.0204L12.9651 16.9012L11.7735 17.0204L17.5148 17.3779M17.9698 17.0204L23.332 17.3779L28.3963 18.3312L22.7958 17.7354L17.5148 17.3779M17.9698 17.0204L17.5148 17.3779",
    stroke: "white",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9924 8.97714C41.9914 9.12013 41.9398 10.5461 42.0391 11.2412C42.0593 11.4319 42.5753 12.8452 43.5881 12.6115C44.8274 12.3255 46.3884 10.3474 45.9118 9.57294C45.4947 8.50045 44.2436 8.7984 42.9924 8.97714Z",
    fill: "#E75300"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04268 8.26168C4.04363 8.40467 4.3255 8.85748 4.32538 10.407C4.30523 10.5977 4.8616 12.671 2.44693 11.896C0.571751 11.2941 -0.353328 9.63198 0.123312 8.85748C1.22713 7.90465 1.7915 8.08294 3.04268 8.26168Z",
    fill: "#E75300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindshieldOut);
export default __webpack_public_path__ + "static/media/windshield-out.20f2be8cfd6fa0556c1d8cf6caf8db0e.svg";
export { ForwardRef as ReactComponent };